// Dans src/App.js
import React, { useEffect, useState } from 'react'; // <-- Ajout de useState

// --- Importations des composants du site ---
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import FeaturedProducts from './components/FeaturedProducts';
import OpeningHours from './components/OpeningHours';
import LocationMap from './components/LocationMap';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import MenuCarte from './components/MenuCarte';
import BookingForm from './components/BookingForm';
import Events from './components/Events';
import Platters from './components/Platters';
import Testimonials from './components/Testimonials';
import GoogleReviews from './components/GoogleReviews';
// import Instagram from './components/Instagram'; // Pas utilisé dans votre App.js actuel
import FacebookFeed from './components/FacebookFeed';
import FloatingButtons from './components/FloatingButtons';

// --- Importation du CSS global ---
import './App.css';
import InstagramFeed from './components/InstagramFeed';

function App() {
  // État pour stocker l'événement 'beforeinstallprompt' et contrôler l'affichage du bouton
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);

    // Gère l'événement 'beforeinstallprompt' pour les PWA
    const handler = (e) => {
      // Empêche l'affichage automatique de la bannière d'installation du navigateur
      e.preventDefault(); 
      // Stocke l'événement pour pouvoir le déclencher plus tard via le bouton
      setDeferredPrompt(e);
      // Affiche le bouton d'installation dans le footer
      setShowInstallButton(true); 
    };

    // Ajoute l'écouteur d'événement
    window.addEventListener('beforeinstallprompt', handler);

    // Fonction de nettoyage pour retirer l'écouteur lorsque le composant est démonté
    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []); // Le tableau vide [] assure que cet effet ne s'exécute qu'une seule fois au montage du composant

  // Fonction appelée lorsque l'utilisateur clique sur le bouton "Installer l'application"
  const handleInstallClick = async () => {
    if (deferredPrompt) {
      // Déclenche l'invite d'installation du navigateur
      deferredPrompt.prompt();

      // Attend la réponse de l'utilisateur (accepté ou refusé)
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`Installation PWA : ${outcome}`);

      // Si l'utilisateur accepte l'installation, on cache le bouton
      if (outcome === 'accepted') {
        setShowInstallButton(false);
        setDeferredPrompt(null); // Réinitialise l'événement stocké
      }
      // Si l'utilisateur refuse, le bouton peut rester caché ou être affiché à nouveau selon la stratégie UX
      // Dans cet exemple, il reste caché une fois le prompt utilisé pour éviter de spammer l'utilisateur.
    }
  };

  return (
    <div className="App"> {/* Votre classe 'App' existante */}
      <>
        <Navbar />
        <Hero />
        <About />
        <Platters />
        <MenuCarte />
        <FeaturedProducts />
        <InstagramFeed />
        <FacebookFeed />
        <Gallery />
        <GoogleReviews />
        <Events />

        {/* Section Réservation */}
        <section id="reservation" className="booking-section">
          <div className="container">
            <BookingForm />
          </div>
        </section>

        {/* Section Localisation & Horaires */}
        <section id="location" className="location-hours-section">
          <div className="container">
            <div className="location-hours-wrapper">
              <LocationMap />
              <OpeningHours />
            </div>
          </div>
        </section>

        {/* Footer - Passage des props pour le bouton PWA */}
        {/* showInstallButton contrôle la visibilité du bouton */}
        {/* onInstallClick est la fonction à appeler quand le bouton est cliqué */}
        <Footer 
          showInstallButton={showInstallButton} 
          onInstallClick={handleInstallClick} 
        />

        {/* Floating Buttons (Phone & Scroll to Top) */}
        <FloatingButtons />
      </>
    </div>
  );
}

export default App;
